import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaArrowLeft } from 'react-icons/fa';
import styles from './pagina_brunovitaltattoo.module.scss';
import Foto from './src/background-links.png';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import { INSTAGRAM_URL, MAPS_URL, WHATSAPP_DEFAULT, useBrunoBackground } from './dados_brunovitaltattoo.ts';

const ease = [0.22, 1, 0.36, 1] as const;

const ESPECIALIDADES = [
    'Realismo preto e cinza',
    'Cobertura',
    'Fine line',
    'Blackwork',
    'Sketch',
    'Oriental',
];

const SECOES = [
    {
        titulo: 'Trajetória',
        texto: 'Com mais de 15 anos de carreira, Bruno Vital é especialista em Realismo Preto e Cinza e Cobertura, unindo técnica, criatividade e precisão para transformar ideias e histórias em tatuagens únicas. Também atua em diferentes estilos, como Fine Line, Blackwork, Sketch e Oriental, desenvolvendo trabalhos que expressam identidade artística e atenção aos detalhes.',
    },
    {
        titulo: 'Aprimoramento',
        texto: 'Premiado em diversos eventos de tatuagem, investe constantemente em aprimoramento profissional, participando de cursos e eventos do segmento para elevar continuamente o nível de sua arte.',
    },
    {
        titulo: 'Arte autoral',
        texto: 'Seu trabalho é marcado pela criação de artes autorais e projetos exclusivos, desenvolvidos de forma personalizada para cada cliente. Na especialidade de cobertura, utiliza sua experiência para transformar tatuagens antigas em novos projetos, criando novas possibilidades artísticas para quem deseja ressignificar sua história na pele.',
    },
    {
        titulo: 'Experiência internacional',
        texto: 'Com experiência em atendimentos internacionais, Bruno leva sua arte além das fronteiras, mantendo o compromisso com a excelência, a qualidade e a satisfação de cada cliente.',
    },
    {
        titulo: 'Atendimento privado',
        texto: 'Realiza atendimentos privados, em um ambiente reservado, confortável e cuidadosamente preparado para proporcionar uma experiência exclusiva, com atenção individualizada do início ao fim.',
    },
];

const fadeUp = {
    hidden: { opacity: 0, y: 16 },
    show: { opacity: 1, y: 0, transition: { duration: 0.5, ease } },
};

const Sobremim_brunovitaltattoo: React.FC = () => {
    useBrunoBackground();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.pagina} lang="pt-BR">
            <div className={styles.header}>
                <Link to="/brunovitaltattoo" className={styles.backButton} aria-label="Voltar">
                    <FaArrowLeft />
                </Link>
                <h1 className={styles.headerTitle}>Sobre mim</h1>
            </div>

            <motion.img
                className={styles.portrait}
                src={Foto}
                alt="Bruno Vital"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.9, ease }}
            />

            <div className={styles.page}>
                <p className={styles.eyebrow}>Tatuador</p>
                <h2 className={styles.name}>Bruno Vital</h2>

                <div className={styles.chips}>
                    {ESPECIALIDADES.map((item) => (
                        <span key={item} className={styles.chip}>
                            {item}
                        </span>
                    ))}
                </div>

                {SECOES.map((secao, index) => (
                    <motion.section
                        key={secao.titulo}
                        className={styles.section}
                        variants={fadeUp}
                        initial="hidden"
                        whileInView="show"
                        viewport={{ once: true, amount: 0.35 }}
                        transition={{ delay: index * 0.04 }}
                    >
                        <h3 className={styles.sectionTitle}>{secao.titulo}</h3>
                        <p className={styles.paragraph}>{secao.texto}</p>
                    </motion.section>
                ))}

                <p className={styles.quote}>
                    Arte, técnica e dedicação em cada detalhe. Uma história eternizada na pele.
                </p>

                <div className={styles.cta}>
                    <a
                        href={WHATSAPP_DEFAULT}
                        className={styles.ctaBtn}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <WhatsappIcon height="22" color="#c4a574" />
                        Agendar
                    </a>
                </div>
            </div>

            <div className={styles.footer}>
                <div className={styles.divSocials}>
                    <a href={WHATSAPP_DEFAULT} className={styles.socials} target="_blank" rel="noopener noreferrer">
                        <div className={styles.iconPlaceholder}>
                            <WhatsappIcon height="26" color="#c4a574" />
                        </div>
                        <span>WhatsApp</span>
                    </a>
                    <a href={MAPS_URL} className={styles.socials} target="_blank" rel="noopener noreferrer">
                        <div className={styles.iconPlaceholder}>
                            <MapsIcon height="26" color="#c4a574" />
                        </div>
                        <span>Localização</span>
                    </a>
                    <a href={INSTAGRAM_URL} className={styles.socials} target="_blank" rel="noopener noreferrer">
                        <div className={styles.iconPlaceholder}>
                            <InstagramIcon height="22" color="#c4a574" />
                        </div>
                        <span>Instagram</span>
                    </a>
                </div>
                <div className={styles.signature}>
                    Desenvolvido por{' '}
                    <a href="https://www.linksvibe.com.br" target="_blank" rel="noreferrer">
                        Links Vibe
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Sobremim_brunovitaltattoo;
